<div class="security-panel">
  <!-- Who currently has access -->
  <div class="assigned">
    <span class="group-label">{{ 'ReportSecurity-WhoCanView' | translate: {Default: "Who can view this report"} }}</span>

    <ng-container *ngIf="loadingAssigned; else assignedList">
      <ngx-skeleton-loader count="1" [theme]="{ 'height.px': 32, 'border-radius': '999px', 'width.px': 180 }"></ngx-skeleton-loader>
    </ng-container>

    <ng-template #assignedList>
      <div class="chips" *ngIf="selectedRoles.size > 0; else noRoles">
        <span class="role-chip" *ngFor="let role of selectedRoleList; trackBy: trackByRoleId">
          <mat-icon class="material-icons-outlined" aria-hidden="true">shield</mat-icon>
          <span class="role-chip-name">{{ role.name }}</span>
          <button type="button" class="role-chip-remove"
            [attr.aria-label]="('Remove' | translate: {Default: 'Remove'}) + ' ' + role.name"
            (click)="removeRole(role.id)">
            <mat-icon class="material-icons-outlined" aria-hidden="true">close</mat-icon>
          </button>
        </span>
      </div>

      <ng-template #noRoles>
        <p class="empty-state">{{ 'ReportSecurity-NoRoles' | translate: {Default: "No roles assigned yet. Only Reports Administrators can view this report."} }}</p>
      </ng-template>
    </ng-template>

    <p class="hint">
      <mat-icon class="material-icons-outlined" aria-hidden="true">info</mat-icon>
      {{ 'ReportSecurity-AdminHint' | translate: {Default: "Reports Administrators always have full access."} }}
    </p>
  </div>

  <!-- Add / remove roles -->
  <div class="picker">
    <span class="group-label">{{ 'ReportSecurity-AllRoles' | translate: {Default: "Security roles"} }}</span>

    <mat-form-field appearance="fill" class="search-field" subscriptSizing="dynamic">
      <mat-label>{{ 'ReportSecurity-FindRole' | translate: {Default: "Find a role"} }}</mat-label>
      <mat-icon matPrefix class="material-icons-outlined" aria-hidden="true">search</mat-icon>
      <input matInput [(ngModel)]="searchValue" (input)="onSearch()" autocomplete="off">
      <button *ngIf="searchValue" matSuffix mat-icon-button type="button"
        [attr.aria-label]="'ClearSearch' | translate: {Default: 'Clear search'}" (click)="clearSearch()">
        <mat-icon class="material-icons-outlined" aria-hidden="true">close</mat-icon>
      </button>
    </mat-form-field>

    <ng-container *ngIf="loadingRoles && roles.length === 0; else roleList">
      <ngx-skeleton-loader count="4" [theme]="{ 'height.px': 40, 'border-radius': '10px' }"></ngx-skeleton-loader>
    </ng-container>

    <ng-template #roleList>
      <ul class="role-list" *ngIf="roles.length > 0; else noMatches" [class.loading]="loadingRoles">
        <li *ngFor="let role of roles; trackBy: trackByRoleId">
          <mat-checkbox setColor="primaryColour" color="primary" [checked]="isSelected(role)" (change)="toggleRole(role)">
            {{ role.name }}
          </mat-checkbox>
        </li>
      </ul>

      <ng-template #noMatches>
        <p class="empty-state">{{ 'ReportSecurity-NoMatches' | translate: {Default: "No roles match your search."} }}</p>
      </ng-template>

      <div class="pager" *ngIf="totalRoles > pageSize">
        <span>{{ skip + 1 }}–{{ rangeEnd }} {{ 'Grid-Pager-Of' | translate: {Default: "of"} }} {{ totalRoles }}</span>
        <button mat-icon-button type="button" class="icon-button" [disabled]="skip === 0 || loadingRoles" (click)="changePage(-1)"
          [attr.aria-label]="'PreviousPage' | translate: {Default: 'Previous page'}">
          <mat-icon class="material-icons-outlined" aria-hidden="true">chevron_left</mat-icon>
        </button>
        <button mat-icon-button type="button" class="icon-button" [disabled]="rangeEnd >= totalRoles || loadingRoles" (click)="changePage(1)"
          [attr.aria-label]="'NextPage' | translate: {Default: 'Next page'}">
          <mat-icon class="material-icons-outlined" aria-hidden="true">chevron_right</mat-icon>
        </button>
      </div>
    </ng-template>
  </div>

  <footer class="panel-footer">
    <span class="save-state" *ngIf="isDirty">
      <span class="dot"></span>
      {{ 'UnsavedChanges' | translate: {Default: "Unsaved changes"} }}
    </span>
    <button class="rounded-button" mat-flat-button setColor="primaryColour" color="primary"
      [disabled]="!isDirty || saving || loadingAssigned"
      appPreventDoubleClick (throttledClick)="save()">
      {{ 'SaveAccess' | translate: {Default: "Save access"} }}
    </button>
  </footer>
</div>
